import { render, staticRenderFns } from "./vehiclesMake.vue?vue&type=template&id=6ab17bda"
import script from "./vehiclesMake.vue?vue&type=script&lang=js"
export * from "./vehiclesMake.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports